import { __extends } from "tslib";
import { ASObject } from '@awayfl/avm2';
var TextColorType = /** @class */ (function (_super) {
    __extends(TextColorType, _super);
    function TextColorType() {
        return _super.call(this) || this;
    }
    TextColorType.classInitializer = null;
    TextColorType.classSymbols = null;
    TextColorType.instanceSymbols = null;
    TextColorType.DARK_COLOR = 'dark';
    TextColorType.LIGHT_COLOR = 'light';
    return TextColorType;
}(ASObject));
export { TextColorType };
